
























import { Component, Vue } from 'vue-property-decorator';

const links = [
  { label: 'Edit', icon: 'edit', to: '/' },
  { label: 'Reports', icon: 'archive', to: '/reports' },
];

@Component
export default class StandardLayoutNav extends Vue {

  activeTab!: number;
  links = links;

  beforeMount() {
    this.activeTab = links.findIndex(link => link.to === this.$route.path);
  }

  navigateTo(newTab: number) {
    const link = this.links[newTab];
    if (this.$route.path !== link.to) {
      this.$router.push(link.to);
    }
  }

}
